import { render, staticRenderFns } from "./AutoQr.vue?vue&type=template&id=a87bacee&scoped=true"
import script from "./AutoQr.vue?vue&type=script&lang=js"
export * from "./AutoQr.vue?vue&type=script&lang=js"
import style0 from "./AutoQr.vue?vue&type=style&index=0&id=a87bacee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87bacee",
  null
  
)

export default component.exports